import VueRouter from 'vue-router';
import swal from 'sweetalert2';
import store from '../store';

class Router extends VueRouter {
  constructor(options) {
    super(options);
    this.beforeEach((to, from, next) => {
      const permissions = store.getters.getAuth ? store.getters.getAuth.permission : [];
      const granted = this.isPathGranted(to.meta.grants, permissions);
      if (!granted) {
        swal({
          text: 'Access denied',
          type: 'error',
          timer: 5000,
          confirmButtonText: 'Close',
        }).catch(swal.noop);
        next({ path: from.fullPath });
        return;
      }
      next();
    });
    // this.afterEach((to, from) => {
    //   store.dispatch('trackEvent', {
    //     name: "Navigation",
    //     options: {
    //       from: from.fullPath,
    //       to: to.fullPath,
    //     }
    //   });
    // })
  }

  canSee(need) {
    const newNeed = Array.isArray(need) ? need : [need];
    const permissions = store.getters.getAuth ? store.getters.getAuth.permission : [];

    if (!permissions) {
      return false;
    }

    const res = newNeed.filter(item => permissions.includes(item));

    if (res.length) {
      return true;
    }

    return newNeed.filter(i => permissions.includes(i.split('.').shift())).length;
  }

  isPathGranted(routeGrants, grants) {
    if (routeGrants[0] === '*') {
      return true;
    }

    if (!grants) {
      return true;
    }

    const res = routeGrants.filter(item => grants.includes(item));
    if (res.length) {
      return true;
    }

    return routeGrants.filter(i => grants.includes(i.split('.').shift())).length;
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/helpers/Router.js